import {withRouter as router} from "react-router-dom";
import React, {useEffect, useState} from "react";
import qs from '../../utils/qs'
import './css/merchant.sass'
import {useDispatch, useSelector} from "react-redux";
import {setSubMerchantMaterialInfo, subMerchantMaterialInfoSelector} from "../../store/merchant";
import Progress from './components/progress';
import {
    CONTRACT_INTERVIEW,
    MATERIAL_FILL_STEP,
    SELECTED_ORGANIZATION, SIGNED,
    SUBMIT_MATERIAL, WAIT_SIGN, WX_ACCOUNT_VERIFY,
    WX_PASSED, WX_REFUSED
} from "./wechatSubMchApplicationStep";
import BeginStep from "./components/beginStep";
import SelectOrganizationType from "./components/selectOrganizationType";
import SubMerchantMaterials from "./components/subMchMaterial";
import {Passed, Refuse, SignQRCode, Success, WaitAccountVerify, WaitCheck} from "./components/wxCheckedResult";
import EventDispatcher from "../../events";
import {WxSubMchStateQueryEvent} from "../../events/WxSubMchStateQueryEvent";

const Steps = (props) => {
    let {step} = props;
    switch (step) {
        case CONTRACT_INTERVIEW:
            return (<BeginStep/>);
        case SELECTED_ORGANIZATION:
            return (<SelectOrganizationType/>);
        case MATERIAL_FILL_STEP:
            return (<SubMerchantMaterials/>);
        case SUBMIT_MATERIAL:
            return (<WaitCheck/>);
        case WX_ACCOUNT_VERIFY:
            return (<WaitAccountVerify/>);
        case WX_REFUSED:
            return (<Refuse/>);
        case WX_PASSED:
            return (<Passed/>);
        case WAIT_SIGN:
            return (<SignQRCode/>);
        case SIGNED:
            return (<Success/>);
        default:
            return null;
    }
};
const Merchant = (props) => {
    const subMerchantMaterialInfo = useSelector(subMerchantMaterialInfoSelector);
    const dispatch = useDispatch();
    const step = qs.hrefParam('step');
    if (step !== undefined && step !== null) {
        let id = setTimeout(() => {
            dispatch(setSubMerchantMaterialInfo({step: parseInt(step)}));
            clearTimeout(id);
        }, 200);
    }
    useEffect(async () => {
        if ((step === undefined || step === null)) {
            dispatch(setSubMerchantMaterialInfo({step: CONTRACT_INTERVIEW}));
        }
        await EventDispatcher.dispatch(new WxSubMchStateQueryEvent());
    }, []);
    useEffect(() => {

    }, [subMerchantMaterialInfo.step]);
    let query = new URLSearchParams(props.location.search);
    useEffect(() => {
        EventDispatcher.dispatch(new WxSubMchStateQueryEvent());
    }, [
        query.get('token')
    ]);
    let boxStyle = {padding: '20px 40px'};
    return (<div className='merchant'>
        <Progress step={subMerchantMaterialInfo.step}/>
        <div className="steps" style={boxStyle}>
            <Steps step={subMerchantMaterialInfo.step}/>
        </div>
    </div>);
};


export default router(Merchant);